import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useConnectResource } from '@/composables/resources/useConnectResource.js'
import Crop from '@/models/Crop.js'

export const useCropStore = defineStore('cropStore', () => {
  let syncableModel = useSyncableModel(useConnectResource('crops'), {
    className: Crop.modelName.name,
    paramKey: Crop.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
